import { useQuery } from '@apollo/client';
import { QUERY_GET_TENANTS } from 'graphql/queries/tenants';
import { QUERY_GET_USERS } from 'graphql/queries/users';
import { IGetUsers, IUser } from 'views/backoffice/users/types';
import { EntityType, FindManyEntityTypes, FindManyEntityTypesVariables, GetEntityMetadataFields, MetadataField } from '../types';
import { QUERY_FIND_MANY_ENTITY_TYPES, QUERY_GET_ENTITY_METADATA_FIELDS } from 'graphql/queries/businessEntities';
import { useMemo } from 'react';
import { IGetTenants, ITenant } from 'types/queries';

export const useDropdownsData = () => {
    const { data: tenantsData, loading: loadingTenantsData } = useQuery<IGetTenants>(QUERY_GET_TENANTS);
    const { loading: loadingUsers, data: usersQueryData } = useQuery<IGetUsers>(QUERY_GET_USERS);
    const { loading: loadingEntityTypes, data: entityTypesData } = useQuery<FindManyEntityTypes, FindManyEntityTypesVariables>(
        QUERY_FIND_MANY_ENTITY_TYPES,
        { variables: { data: { enabled: true } } }
    );
    const { loading: loadingMetadata, data: metadataData } = useQuery<GetEntityMetadataFields>(QUERY_GET_ENTITY_METADATA_FIELDS);

    const users = useMemo(() => usersQueryData?.getSaasUsers || [], [usersQueryData?.getSaasUsers]);
    const usersById = useMemo(() => users.reduce<Record<number, IUser>>((acc, user) => ({ ...acc, [+user.id]: user }), {}), [users]);
    const tenants = useMemo(() => tenantsData?.getTenants || [], [tenantsData]);
    const tenantsById = useMemo(() => tenants.reduce<Record<number, ITenant>>((acc, el) => ({ ...acc, [+el.id]: el }), {}), [tenants]);
    const entityTypes = entityTypesData?.findManyEntityTypes || [];
    const entityTypesById = entityTypes.reduce<Record<number, EntityType>>((acc, el) => ({ ...acc, [+el.id]: el }), {});
    const metadataFields = useMemo(() => metadataData?.getEntityMetadataFields || [], [metadataData?.getEntityMetadataFields]);
    const metadataFieldsByDisplayName: Record<string, MetadataField> = useMemo(
        () => metadataFields.reduce((acc, el) => ({ ...acc, [el.displayName]: el }), {}),
        [metadataFields]
    );
    const geographicLocationListId = useMemo(() => {
        const geoField = metadataFields.find((field) => field.tag === 'geographicalLocation');
        return geoField?.list?.id ? Number(geoField.list.id) : null;
    }, [metadataFields]);
    const loading = loadingTenantsData || loadingUsers || loadingEntityTypes || loadingMetadata;

    return {
        tenants,
        tenantsById,
        users,
        usersById,
        entityTypes,
        entityTypesById,
        metadataFields,
        metadataFieldsByDisplayName,
        geographicLocationListId,
        loading
    };
};
